export default __webpack_public_path__ + "static/media/deco-img(2).12e32769.png";